import SwiperWrapper from '@/pages/home/components/SwiperWrapper';
import MainBanner from '@/pages/home/components/MainBanner';
import SpecialFunctionBanner from '@/pages/home/components/SpecialFunctionBanner';
import DifferentFunctionBanner from '@/pages/home/components/DifferentFunctionBanner';
import AdvertisingBanner from '@/pages/home/components/AdvertisingBanner';
import ServiceBanner from '@/pages/home/components/ServiceBanner';
import BusinessBanner from '@/pages/home/components/BusinessBanner';
import ErpBanner from '@/pages/home/components/ErpBanner';
import CommunicationBanner from '@/pages/home/components/CommunicationBanner';
import QuestionBanner from '@/pages/home/components/QuestionBanner';
import useHome from '@/pages/home/hook/useHome';
import YoutubeSwiper from './components/YoutubeSwiper';
import PromotionBanner from './components/PromotionBanner';
import LayerPopupGroup from '@/components/LayerPopupGroup';

const HomePage = () => {
	useHome();

	return (
		<>
			<main id="main" className="main">
				<SwiperWrapper />
				<PromotionBanner />
				{/* <YoutubeSwiper /> */}
				<MainBanner />
				<SpecialFunctionBanner />
				<ServiceBanner />
				{/* <BusinessBanner /> */}
				<DifferentFunctionBanner />
				<ErpBanner />
				<AdvertisingBanner />
				<CommunicationBanner />
				<QuestionBanner />
			</main>
			<LayerPopupGroup />
		</>
	);
};

export default HomePage;
